import Minze from 'minze'
import * as Elements from './components'
import * as constants from "./constants";
import template from './template'
import {TjWrapper} from './components/tj-wrapper'
import MainModule from './modules/main'
import './modules/locale'
import { SquidexTextLabels } from './modules/squidex/labels';
declare global {
  interface Window {
    TJ_MAIN_MODULE: MainModule;
    TJ_WEBCOMPONENTS_CONSTANTS: any;
    //TJ_SEARCH_CONFIGS: any;
  }
}

const app = document.querySelector<HTMLDivElement>('#app') ?? null
if (app) app.innerHTML = template

//window.TJ_SEARCH_CONFIGS = window.TJ_SEARCH_CONFIGS || constants?.config?.searchConfigs || {};
window.TJ_WEBCOMPONENTS_CONSTANTS =  window.TJ_WEBCOMPONENTS_CONSTANTS || constants; 
window.TJ_MAIN_MODULE = window.TJ_MAIN_MODULE || MainModule.getInstance();

new SquidexTextLabels().initialize()
.then(()=>{
  Minze.defineAll(Elements);
  Minze.define('tj-wrapper', TjWrapper);
})
.catch(()=>{
  Minze.defineAll(Elements);
  Minze.define('tj-wrapper', TjWrapper);
});
